// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Zd1Q","footer":"Form_footer__3aJsf"};